module.exports = __webpack_public_path__ + "img/encom_official.fd455e28.png";